import React, { Component } from 'react';
import i18n from '../../i18n';
import FacebookIcon from '../../img/facebookIcon.png';
import TwitterIcon from '../../img/twitterIcon.png';
import InstagramIcon from '../../img/instagramIcon.png';

class Footer extends Component{
    render(){
        return(
            <div className={"footer"} style={styles.footer}>
                    <div key="element" style={styles.element}>
                    <div style={styles.label}>
                        <a style={{color:"white"}}>{i18n.t('footer.operating_company')}</a>
                        <br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a href="https://geo-farm.com/" style={{color:"white", lineHeight:"28px"}} target="_Blank">{i18n.t('footer.geo_farm')}</a>
                        <br/>
                        <div style={{marginLeft:"15px"}}>
                            <a className={"facebookIcon"} href="https://www.facebook.com/%E3%82%B8%E3%82%AA%E3%83%95%E3%82%A1%E3%83%BC%E3%83%A0%E5%85%AB%E5%B9%A1%E5%B9%B3-1544526485801477/" target="_Blank">
                                <img src={FacebookIcon} style={styles.icon}></img>
                            </a>
                            <a className={"twitterIcon"} href="https://twitter.com/geo__farm" target="_Blank">
                                <img src={TwitterIcon} style={styles.icon}></img>
                            </a>
                            <a className={"instagramIcon"} href="https://www.instagram.com/geofarm.hachimantai/" target="_Blank">
                                <img src={InstagramIcon} style={styles.icon}></img>
                            </a>
                        </div>
                    </div>
                    <div style={styles.label}>
                        <br/>
                        <a href="https://www.caica-technologies.co.jp/" style={{color:"white", lineHeight:"28px"}} target="_Blank">{i18n.t('footer.caica')}</a>
                        <br/>
                        <div style={{marginLeft:"25px"}}>
                            <a className={"facebookIcon"} href="https://www.facebook.com/CAICATechnologies.jp/" target="_Blank">
                                <img src={FacebookIcon} style={styles.icon2}></img>
                            </a>
                            <a className={"twitterIcon"} href="https://twitter.com/CAICATech" target="_Blank">
                                <img src={TwitterIcon} style={styles.icon2}></img>
                            </a>
                            <a className={"instagramIcon"} href="https://www.instagram.com/caicatechnologies" target="_Blank">
                                <img src={InstagramIcon} style={styles.icon2}></img>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
}

const styles = {
    footer:{
        // background:"#DCCBAA",
        background:"black",
        height:"120px",
        bottom:"0",
    },
    element:{
        position:"relative",
        left:"50%",
        marginLeft:"-190px",
        width:"530px"
    },
    label:{
        float:"left",
        paddingRight:"70px",
        marginTop:"13px"
    },
    icon:{
        height:"30px",
        width:"30px",
        borderRadius:"8px",
        display:"inline",
        marginLeft:"20px",
        marginTop:"3px"
    },
    icon2:{
        height:"30px",
        width:"30px",
        borderRadius:"8px",
        display:"inline",
        marginRight:"20px",
        marginTop:"3px"
    }
}

export default Footer;